// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.rjnVBMeIIE2u2K {
  display: block;
  /* stylelint-disable-next-line design-system/ensure-design-token-usage */
  padding-left: 5px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
}
.rjnVBMeIIE2u2K a {
  color: var(--ds-text-subtle, #44546f);
  font-weight: var(--ds-font-weight-bold, bold);
  text-decoration: underline;
  cursor: pointer;
}
._1IC3FpWXLELQc {
  padding-left: var(--ds-space-050, 4px);
  vertical-align: middle;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"memberActivityDetails": `rjnVBMeIIE2u2K`,
	"visibilityIcon": `_1IC3FpWXLELQc`
};
export default ___CSS_LOADER_EXPORT___;
